import { toOptions } from '@/utils'
import { Input } from '@material-tailwind/react'
import { useFormikContext } from 'formik'
import { useMemo, useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import CustomSelect from '@/shared/components/custom-select'
import { createSearchParams } from 'react-router-dom'
import { useGetCitiesQuery } from '@/store/services/city.service'

export const AddressForm = ({ required = false, isClearable = false }) => {
  const { values, setFieldValue } = useFormikContext()
  const { t } = useTranslation()
  const { data: cities = [], isLoading: isLoadingCities } = useGetCitiesQuery()
  const {
    data: [currentCity = {}] = [],
    isSuccess: isSuccessCurrentCity
  } = useGetCitiesQuery(createSearchParams({ state_id: values?.address_attributes?.state_id }).toString(), { skip: !values?.address_attributes?.state_id })

  const [selectedCity, setSelectedCity] = useState(null)
  const [stateOptions, setStateOptions] = useState([])

  const cityOptions = useMemo(() => {
    return toOptions({ data: cities })
  }, [cities])

  useEffect(() => {
    if (!selectedCity?.value) return

    setStateOptions(toOptions({ data: selectedCity.resource.states }))
  }, [selectedCity])

  useEffect(() => {
    if (!isSuccessCurrentCity) return

    setSelectedCity(toOptions({ data: [currentCity] })[0])
  }, [isSuccessCurrentCity])

  const handleCityChange = (option) => {
    setSelectedCity(option)
    setStateOptions([])
    setFieldValue('address_attributes.state_id', '')
  }

  return (
    <>
      <CustomSelect
        required={required}
        placeholder={t('city.one')}
        options={cityOptions}
        onChange={handleCityChange}
        value={selectedCity}
        isLoading={isLoadingCities}
        isClearable={isClearable}
      />

      <CustomSelect
        required={required}
        placeholder={t('state.one')}
        isDisabled={!selectedCity?.value}
        options={stateOptions}
        name='address_attributes.state_id'
        value={stateOptions.find(({ value: stateId }) => stateId === values?.address_attributes?.state_id)}
        onChange={(option) => setFieldValue('address_attributes.state_id', option?.value || '')}
        isClearable={isClearable}
      />

      <Input
        required={required}
        label={t('street.withNumber')}
        name='address_attributes.street'
        value={values?.address_attributes?.street}
        onChange={({ target: { value } }) => setFieldValue('address_attributes.street', value)}
      />
    </>
  )
}

AddressForm.propTypes = {
  required: PropTypes.bool,
  isClearable: PropTypes.bool
}
